import '@babel/polyfill'
import Vue from 'vue'
import 'mutationobserver-shim'
import './Utils/fliter'
import App from './App.vue'
import router from './router'
import store from './store'
import Raphael from 'raphael/raphael'
// import getPushNotification from './Utils/push-notification'
import './plugins'
// import './registerServiceWorker'
import i18n from './i18n'
import './directives'
// import VueSocketIO from 'vue-socket.io'
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, options)
// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

global.Raphael = Raphael

// Toastr config
const toastrConfigs = {
  position: 'top right',
  errorColor: '#D6E09B',
  warningColor: '#D6E09B',
  showDuration: 1000,
  timeOut: 3000
}

Vue.use(CxltToastr, toastrConfigs)
// end of Toastr config

Vue.config.productionTip = false

// vue global components
Vue.component('multi-document-upload', require('./components/custom/DocumentUpload').default)
Vue.component('beneficiary-account', require('./components/custom/BeneficiaryAccount').default)
Vue.component('beneficiary-account-grant', require('./components/custom/BeneficiaryAccountGrant').default)
Vue.component('address-component', require('./components/custom/Address').default)
Vue.component('view-address', require('./components/custom/ViewAddress').default)
Vue.component('view-grant-address', require('./components/custom/ViewGrantAddress').default)
Vue.component('view-beneficiary', require('./components/custom/ViewBeneficiary').default)
Vue.component('view-document', require('./components/custom/ViewDocument').default)
Vue.component('grant-address', require('./components/custom/GrantAddress').default)
Vue.component('progress-step', require('./components/custom/Stepper').default)
// pie-chart / stacked-chart: only used by the unrouted GrantAllowance2backup.vue; both import apexcharts,
// which pulled it into chunk-vendors on every page.
// Vue.component('pie-chart', require('./components/custom/charts/PieChart').default)
// Vue.component('stacked-chart', require('./components/custom/charts/StackedChart').default)
Vue.component('download-application-form', require('./components/custom/DownloadApplicationForm').default)
/* Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://syn-node-notification.herokuapp.com', // dont change this please
    vuex: {
      // store,
      actionPrefix: 'SOCKET_'
    },
  options: {}
})) */
/* const getNotification = {
  pushNotification: function (data) {
    getPushNotification(data)
  }
} */

// generate logout event (implemented by hasinur)
window.addEventListener('storage', function (event) {
  if (event.key === 'logout-event') {
    window.location.reload()
  }
}, false)

const vm = new Vue({
  router,
  store,
  i18n,
 /* sockets: getNotification, */
  render: h => h(App)
}).$mount('#app')

window.vm = vm
